import { RugbyFoulGameStage } from '../models/rugby-foul-type';
import { Locales } from './locales';

export const RugbyFoulGameStageLocalization = {
  [Locales.ru]: {
    [RugbyFoulGameStage.start_kick]: 'Начальные удары',
    [RugbyFoulGameStage.open_game]: 'Открытая игра',
    [RugbyFoulGameStage.tackle]: 'Игроки на земле, Захват',
    [RugbyFoulGameStage.ruck_or_maul]: 'Рак, мол',
    [RugbyFoulGameStage.scrum]: 'Схватка',
    [RugbyFoulGameStage.out_and_lineout]: 'Аут и коридор',
    [RugbyFoulGameStage.scoring_field]: 'Зачетное поле',
    [RugbyFoulGameStage.kick_on_goal]: 'Удар по воротам',
    [RugbyFoulGameStage.free_kick]: 'Штрафной, свободный удар',
    [RugbyFoulGameStage.team]: 'Команда',
  },
  [Locales.en]: {
    [RugbyFoulGameStage.start_kick]: 'Initial kicks',
    [RugbyFoulGameStage.open_game]: 'Open game',
    [RugbyFoulGameStage.tackle]: 'Players on the ground, Capture',
    [RugbyFoulGameStage.ruck_or_maul]: 'Ruck, maul',
    [RugbyFoulGameStage.scrum]: 'Scrum',
    [RugbyFoulGameStage.out_and_lineout]: 'Out and lineout',
    [RugbyFoulGameStage.scoring_field]: 'Scoring field',
    [RugbyFoulGameStage.kick_on_goal]: 'Kick on goal',
    [RugbyFoulGameStage.free_kick]: 'Free kick',
    [RugbyFoulGameStage.team]: 'Team',
  }
};
